export const enum RGCheckboxDependency {
  FILL_CALCULATOR = "calculator/calculator-gd/fill-calculator-checkbox",
  FINANCING = "calculator/calculator-gd/financing-checkbox",
  CALCULATOR = "calculator/calculator-gd/enable-calculator",
}

const getCurrentCheckboxDependency = (
  fillCalculatorCheckbox?: boolean,
  financingCheckbox?: boolean
) => {
  if (fillCalculatorCheckbox) {
    return RGCheckboxDependency.FILL_CALCULATOR;
  }

  if (financingCheckbox) {
    return RGCheckboxDependency.FINANCING;
  }

  return RGCheckboxDependency.CALCULATOR;
};

export default getCurrentCheckboxDependency;
